
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/share/s/[shareId]",
      function () {
        return require("private-next-pages/share/s/[shareId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/share/s/[shareId]"])
      });
    }
  